export function shipmentAffProductsByOrderValidate(products){
    var result = true;
    var errors = [];

    result = validateProducts(products, errors);
    
    if(!result) return errors;
    else return result;
}

function validateProducts(products, errors){    
    if (Array.isArray(products) 
    && products.length > 0 
     && products.every(item =>
        typeof item === 'object' &&
        item !== null &&
        typeof item.product_id === 'number' &&
        !isNaN(item.product_id) &&
        typeof item.barcode === 'string' &&
        item.barcode !== '' &&
        typeof item.description === 'string' &&
        item.barcode !== '' &&
        typeof item.quantity === 'number' &&
        !isNaN(item.quantity) &&
        typeof item.warehouse_id === 'number' &&
        !isNaN(item.warehouse_id) &&

        Array.isArray(item.locations) && 
        item.locations.length > 0 &&
        item.locations.every(subitem => 
            typeof subitem.product_id === 'number' && 
            !isNaN(subitem.product_id) &&
            typeof subitem.detail_order_id === 'number' && 
            !isNaN(subitem.detail_order_id) &&
            typeof subitem.detailed_stock_id === 'number' && 
            !isNaN(subitem.detailed_stock_id) 
        ) &&

        typeof item.img === 'string' 
    )) return true;
    else {
        errors.push("products_not_valid")
        return false;
    }
}
